import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { user, login, motifDeconnexion } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  // Retour à la page où l'on était (chemin interne seulement)
  const r = params.get('retour') || '';
  const retour = r.startsWith('/') && !r.startsWith('//') ? r : '/';
  const message = motifDeconnexion === 'inactivite'
    ? 'Vous avez été déconnecté après 30 minutes sans activité. Reconnectez-vous : vous reviendrez sur la page où vous étiez.'
    : (motifDeconnexion === 'expiree' || (r && !motifDeconnexion))
      ? 'Votre session est terminée. Reconnectez-vous : vous reviendrez sur la page où vous étiez.'
      : motifDeconnexion === 'manuelle' ? 'Vous vous êtes déconnecté dans un autre onglet. Reconnectez-vous pour continuer.' : '';

  useEffect(() => {
    if (user && user !== false) {
      navigate(retour, { replace: true });
    }
  }, [user, navigate, retour]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate(retour, { replace: true });
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB] px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-sm border border-[#E5E7EB] p-8">
          <div className="text-center mb-8">
            <img
              src="/icon-512.png"
              alt="DMO Immobilier"
              className="h-16 w-16 object-contain mx-auto mb-4"
              data-testid="login-logo"
            />
            <h1 className="text-2xl font-bold text-[#1F4E79] tracking-tight">DMO Immobilier</h1>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {message && !error && (
              <div className="bg-amber-50 border border-amber-200 text-amber-900 px-4 py-3 rounded-md text-sm" data-testid="login-session">{message}</div>
            )}
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm" data-testid="login-error">
                {error}
              </div>
            )}

            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="h-11 mt-1"
                data-testid="login-email-input"
              />
            </div>

            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="h-11 mt-1"
                data-testid="login-password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full h-11 bg-[#1F4E79] hover:bg-[#1a3e5f] text-white transition-colors"
              disabled={loading}
              data-testid="login-submit-btn"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}